<template>
    <div class=" tw:p-6">
        <div>
            <h3 class="tw:text-lg tw:font-semibold tw:text-gray-900 ">
                Observaciones
            </h3>
            <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:my-1">Observaciones/comentarios a tener en cuenta</p>
        </div>

        <div class="tw:space-y-4">
            <BaseTextarea
                :value="localObservaciones"
                @input="localObservaciones = $event"
                label="Observaciones"
                name="observaciones"
                rows="6"
            />
            
            <div class="tw:flex tw:justify-end">
                <Button
                    @click="guardarObservaciones"
                    :disabled="!ha_cambiado"
                    class="tw:text-xs tw:sm:text-sm"
                >
                    Guardar observaciones
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import BaseTextarea from '@/modules/admin/ui/BaseTextarea.vue'

    const props = defineProps({
        observaciones: {
            type: String,
            default: ''
        }
    })

    const emit = defineEmits(['guardar'])

    const localObservaciones = ref(props.observaciones || '')

    const ha_cambiado = computed(() => {
        return localObservaciones.value !== (props.observaciones || '')
    })

    function guardarObservaciones() {
        emit('guardar', localObservaciones.value)
    }
</script>
